import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Cart, cart_params } from "./../models/cart_model";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/map";
import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ManageNewsLettersService } from 'src/app/views/common/services/manage-news-letters.service';

@Injectable()
export class CartInfoService {
  orderData: any;
  resetForm: Boolean = false;
  totalItem: any = 0;
  totalAmount: number = 0;
  cart_info = cart_params;
  receivedFilter: any;
  editCartItemFilter: any;
  setProductImageFilter: any;
  checkOfferQuantityFilter: any;
  passOrderDataFilter = new BehaviorSubject(this.orderData);
  resetProductForm = new BehaviorSubject(this.orderData);
  constructor(private newslettersrv: ManageNewsLettersService, private http: HttpClient, private route: Router) {
    this.receivedFilter = new EventEmitter<any>();
    this.editCartItemFilter = new EventEmitter<any>();
    this.setProductImageFilter = new EventEmitter<any>();
    this.checkOfferQuantityFilter = new EventEmitter<any>();
  }
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }

  myHeaders = this.setHeader();

  sendSelectedQuantity(value) {
    this.checkOfferQuantityFilter.emit(value);
  }
  sendOrderData(data) {
    this.passOrderDataFilter.next(data);
  }

  getCartItems() {
    // if(cartIds === ""){
    //   cartIds = null;
    // }
    let userInfo = null;
    let sessionId = sessionStorage.getItem("cart_session_id");
    if (sessionId == undefined) {
      sessionId = null;
    }
    if (
      sessionStorage.getItem("account-user") != null &&
      sessionStorage.getItem("account-user") != undefined
    ) {
      userInfo = JSON.parse(sessionStorage.getItem("account-user"));
      let url =
        environment.URL + "/cartInfo/edit/" + userInfo.email + "/" + null;
      return this.http.get(url, { headers: this.myHeaders });
    } else {
      let url = environment.URL + "/cartInfo/edit/" + null + "/" + sessionId;
      return this.http.get(url, { headers: this.myHeaders });
    }
  }

  getUserDetailByEmail(emailValue) {
    let url = environment.URL + "/registerUser/edit/" + emailValue;
    return this.http.get(url, { headers: this.myHeaders });
  }

  addCartInfo(bodyParams: any) {
    let url = environment.URL + "/cartInfo/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateCartInfo(bodyParams: any) {
    let url = environment.URL + "/cartInfo/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateCartOrderInfo(bodyParams: any) {
    let url = environment.URL + "/orderItem/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  deleteCartInfo(cartId) {
    let url = environment.URL + "/cartInfo/delete/" + cartId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveCartDetail(product) {
    let cartActionPromise = new Promise((resolve, reject) => {
      this.addCartInfo(product).subscribe((res: any) => {
        sessionStorage.setItem("FormResetAction", "true");
        sessionStorage.removeItem("proofcardCartIds");
        sessionStorage.removeItem("purchaseSelectedImageCode");
        sessionStorage.removeItem("purchaseSelectedImage");
        this.resetProductForm.next(true);
        this.updateCart();
        resolve(true)
      }, (error) => {
        resolve(false)
      });
    });
    return cartActionPromise;

  }

  updateCartDetail(product) {
    this.updateCartInfo(product).subscribe((res: any) => {
      sessionStorage.removeItem("proofcardCartIds");
      sessionStorage.removeItem("formData");
      sessionStorage.removeItem("purchaseSelectedImageCode");
      sessionStorage.removeItem("purchaseSelectedImage");
      sessionStorage.removeItem("selectedItemToUpdate");
      this.updateCart();
    });
  }

  updateCart() {
    let proofcard_Ids = "";
    if (
      sessionStorage.getItem("username") == "proofcard-user" &&
      sessionStorage.getItem("account-user") == null &&
      sessionStorage.getItem("account-user") == undefined
    ) {
      proofcard_Ids = sessionStorage.getItem("proofcard_Id");
    }
    if (
      sessionStorage.getItem("account-user") != null &&
      sessionStorage.getItem("account-user") != undefined
    ) {
      proofcard_Ids = "";
      let userInfo = JSON.parse(sessionStorage.getItem("account-user"));
      userInfo.proofcards.forEach((element) => {
        if (proofcard_Ids === "") {
          proofcard_Ids = element.proofcardId;
        } else {
          proofcard_Ids = proofcard_Ids + "," + element.proofcardId;
        }
      });
    }
    this.getCartItems().subscribe((res: any) => {
      this.receivedFilter.emit(res.data);
    });
  }

  editCartItem(productDetail) {
    this.editCartItemFilter.emit(productDetail);
  }
  setProductImage(base64IMG) {
    this.setProductImageFilter.emit(base64IMG);
  }

  orderDetails = {
    email: "harshit@esurgentit.com",
    order_item_id: null,
    id: 17,
    product_id: 118,
    proofcard_id: "6404",
    product_name: "Multi Image Pack C",
    selected_fields: "Quantity:1,Price:66.99,CustomerComments:,storeType:School,DigitalProduct:",
    quantity: "1",
    price: "66.99",
    image_name: [
      "http://127.0.0.1/images/proofcard/0379/0379001/01_0379_001_001_a_All.jpg"
    ],
    image_code: [
      "01_0379_001_001"
    ],
    extraPrice: null,
    extraImages: [],
    formData: "[{\"control\":\"Quantity\",\"value\":1},{\"control\":\"Price\",\"value\":\"Price 66.99\"}]",
    cart_session: "1257aa3a-e7b7-432f-aaa2-28561d1c26a0",
    proofcardIdsByImage: "6404",
    isPackage: "true"
  }
}
